function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import fetch from 'node-fetch';
import { mapRawDataToAgent } from '../../client/mappers/AgentMapper';
import { buildUrlQuery } from '../../client/utils/QueryParamUtil';
import { dynamicFaq } from '../../client/store/initialState';
var emptyResult = {
  pageResults: [],
  totalNumberOfPages: 0,
  totalNumberOfAgents: 0
};
var seoEmptyResult = {
  childrenRegions: [],
  neighbourRegions: [],
  neighbourRegionType: '',
  childrenRegionType: ''
};
var nearByAgentsEmptyResult = {
  nearbyAgents: [],
  term: '',
  geoPathUri: ''
};
export function fetchAgentsByGeoPath(_x, _x2) {
  return _fetchAgentsByGeoPath.apply(this, arguments);
}
function _fetchAgentsByGeoPath() {
  _fetchAgentsByGeoPath = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(shapeId, searchId) {
    var pageNumber,
      type,
      sortBy,
      sortOrder,
      parameters,
      url,
      response,
      error,
      result,
      agentSearchResultData,
      hotSeat,
      totalNumberOfPages,
      totalNumberOfAgents,
      _args = arguments,
      _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          pageNumber = _args.length > 2 && _args[2] !== undefined ? _args[2] : 1;
          type = _args.length > 3 && _args[3] !== undefined ? _args[3] : 'unknown';
          sortBy = _args.length > 4 ? _args[4] : undefined;
          sortOrder = _args.length > 5 ? _args[5] : undefined;
          _context.p = 1;
          if (shapeId) {
            _context.n = 2;
            break;
          }
          return _context.a(2, emptyResult);
        case 2:
          parameters = {
            region: shapeId,
            pagenumber: pageNumber,
            type: type,
            searchid: searchId
          };
          if (sortBy) {
            parameters = _objectSpread(_objectSpread({}, parameters), {}, {
              sortby: sortBy,
              sortOrder: sortOrder || 'ASC'
            });
          }
          url = "".concat(process.env.API_ENDPOINT, "/searchagents?").concat(buildUrlQuery(parameters));
          _context.n = 3;
          return fetch(url);
        case 3:
          response = _context.v;
          if (response.ok) {
            _context.n = 4;
            break;
          }
          error = new Error("Could not fetch data for url".concat(url, ". Status: ").concat(response.status));
          console.log(error);
          return _context.a(2, emptyResult);
        case 4:
          _context.n = 5;
          return response.json();
        case 5:
          result = _context.v;
          agentSearchResultData = mapRawDataToAgent(result.data.agentSearchResultData, process.env.DOMAIN);
          hotSeat = pageNumber === 1 && result.data.hotSeat ? mapRawDataToAgent([result.data.hotSeat], process.env.DOMAIN)[0] : undefined;
          totalNumberOfPages = result.data.totalNumberOfPages || 0;
          totalNumberOfAgents = result.data.totalNumberOfAgents || 0;
          return _context.a(2, {
            pageResults: agentSearchResultData,
            hotSeat: hotSeat,
            totalNumberOfPages: totalNumberOfPages,
            totalNumberOfAgents: totalNumberOfAgents
          });
        case 6:
          _context.p = 6;
          _t = _context.v;
          return _context.a(2, emptyResult);
      }
    }, _callee, null, [[1, 6]]);
  }));
  return _fetchAgentsByGeoPath.apply(this, arguments);
}
export function fetchSeoData(_x3, _x4, _x5) {
  return _fetchSeoData.apply(this, arguments);
}
function _fetchSeoData() {
  _fetchSeoData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(shapeId, type, apiEndpoint) {
    var parameters, url, response, error, result, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          if (!(!shapeId || !type)) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, seoEmptyResult);
        case 1:
          parameters = {
            shapeId: shapeId,
            type: type
          };
          url = "".concat(apiEndpoint, "/fetchSeoData?").concat(buildUrlQuery(parameters));
          _context2.n = 2;
          return fetch(url);
        case 2:
          response = _context2.v;
          if (response.ok) {
            _context2.n = 3;
            break;
          }
          error = new Error("Could not fetch seo data for url ".concat(url, ". Status: ").concat(response.status));
          console.log(error);
          return _context2.a(2, seoEmptyResult);
        case 3:
          _context2.n = 4;
          return response.json();
        case 4:
          result = _context2.v;
          return _context2.a(2, result.data);
        case 5:
          _context2.p = 5;
          _t2 = _context2.v;
          console.log("Error fetching seo data: ".concat(_t2));
          return _context2.a(2, seoEmptyResult);
      }
    }, _callee2, null, [[0, 5]]);
  }));
  return _fetchSeoData.apply(this, arguments);
}
export function fetchNearbyAgents(_x6, _x7, _x8) {
  return _fetchNearbyAgents.apply(this, arguments);
}
function _fetchNearbyAgents() {
  _fetchNearbyAgents = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(apiEndpoint, shapeId, domain) {
    var url, response, result;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          url = "".concat(apiEndpoint, "/nearbyagents?shapeId=").concat(shapeId);
          _context3.n = 1;
          return fetch(url);
        case 1:
          response = _context3.v;
          if (response.ok) {
            _context3.n = 2;
            break;
          }
          console.log("Could not fetch data for url ".concat(url, ". Status: ").concat(response.status));
          return _context3.a(2, nearByAgentsEmptyResult);
        case 2:
          _context3.n = 3;
          return response.json();
        case 3:
          result = _context3.v.data;
          return _context3.a(2, {
            nearbyAgents: mapRawDataToAgent(result.agents, domain),
            term: result.seoLabel,
            geoPathUri: result.geoPathUri
          });
      }
    }, _callee3);
  }));
  return _fetchNearbyAgents.apply(this, arguments);
}
export function fetchTeaserData(_x9, _x0) {
  return _fetchTeaserData.apply(this, arguments);
}

// TODO remove testRealtorSsoId once testing is complete
function _fetchTeaserData() {
  _fetchTeaserData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(apiEndpoint, body) {
    var staticTeaserData, url, response, result;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          staticTeaserData = {
            logoUrl: '',
            brandColor: '',
            displayName: '',
            message: '',
            linkDescription: '',
            linkUrl: '',
            agentPictureUrl: ''
          };
          url = "".concat(apiEndpoint, "/teaser");
          _context4.n = 1;
          return fetch(url, {
            method: 'post',
            body: JSON.stringify(body),
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 1:
          response = _context4.v;
          if (response.ok) {
            _context4.n = 2;
            break;
          }
          console.log("Could not fetch data for url ".concat(url, ". Status: ").concat(response.status));
          return _context4.a(2, {
            isLoggedIn: true,
            staticTeaserData: staticTeaserData
          });
        case 2:
          _context4.n = 3;
          return response.json();
        case 3:
          result = _context4.v.data;
          if (result.linkUrl) {
            _context4.n = 4;
            break;
          }
          return _context4.a(2, {
            isLoggedIn: true,
            staticTeaserData: staticTeaserData
          });
        case 4:
          return _context4.a(2, {
            isLoggedIn: true,
            staticTeaserData: {
              logoUrl: result.logoUrl,
              brandColor: result.brandColor ? result.brandColor : '',
              displayName: result.displayName,
              message: result.message,
              linkDescription: result.linkDescription,
              linkUrl: result.linkUrl,
              agentPictureUrl: result.agentPictureUrl
            }
          });
      }
    }, _callee4);
  }));
  return _fetchTeaserData.apply(this, arguments);
}
export function fetchDynamicFaq(_x1, _x10, _x11, _x12) {
  return _fetchDynamicFaq.apply(this, arguments);
}
function _fetchDynamicFaq() {
  _fetchDynamicFaq = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(apiEndpoint, loginData, shapeId, testRealtorSsoId) {
    var url, payload, response, result, positionList;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          url = "".concat(apiEndpoint, "/faq");
          payload = JSON.stringify(_objectSpread(_objectSpread({}, loginData), {}, {
            region: shapeId,
            testRealtorSsoId: testRealtorSsoId
          }));
          console.log('calling ' + url + ' with payload ' + payload);
          _context5.n = 1;
          return fetch(url, {
            method: 'post',
            body: payload,
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 1:
          response = _context5.v;
          if (response.ok) {
            _context5.n = 2;
            break;
          }
          console.log("Could not fetch data for url ".concat(url, ". Status: ").concat(response.status));
          return _context5.a(2, dynamicFaq);
        case 2:
          _context5.n = 3;
          return response.json();
        case 3:
          result = _context5.v.data;
          // TODO enable once not mocked
          /* if (!result.sovEnabled) {
              return dynamicFaq;
          } */
          positionList = [];
          if (result.currentPositionOne && result.gainPositionOne) {
            positionList.push({
              displayName: result.currentPositionOne,
              schaufensterPlacements: result.gainPositionOne.schaufensterPlacements,
              premiumPlacements: result.gainPositionOne.premiumPlacements,
              positionNumber: 1,
              displayPosition: '1',
              visibilityIncreasePercentage: result.gainPositionOne.visibilityIncreasePercentage
            });
          }
          if (result.currentPositionTwo && result.gainPositionTwo) {
            positionList.push({
              displayName: result.currentPositionTwo,
              schaufensterPlacements: result.gainPositionTwo.schaufensterPlacements,
              premiumPlacements: result.gainPositionTwo.premiumPlacements,
              positionNumber: 2,
              displayPosition: '2',
              visibilityIncreasePercentage: result.gainPositionOne.visibilityIncreasePercentage
            });
          }
          if (result.currentPositionThree && result.gainPositionThree) {
            positionList.push({
              displayName: result.currentPositionThree,
              schaufensterPlacements: result.gainPositionThree.schaufensterPlacements,
              premiumPlacements: result.gainPositionThree.premiumPlacements,
              positionNumber: 3,
              displayPosition: '3',
              visibilityIncreasePercentage: result.gainPositionOne.visibilityIncreasePercentage
            });
          }
          if (result.currentPositionFour && result.gainPositionFour) {
            positionList.push({
              displayName: result.currentPositionFour,
              schaufensterPlacements: result.gainPositionFour.schaufensterPlacements,
              premiumPlacements: result.gainPositionFour.premiumPlacements,
              positionNumber: 4,
              displayPosition: '4',
              visibilityIncreasePercentage: result.gainPositionOne.visibilityIncreasePercentage
            });
          }
          if (result.currentPositionFive && result.gainPositionFive) {
            positionList.push({
              displayName: result.currentPositionFive,
              schaufensterPlacements: result.gainPositionFive.schaufensterPlacements,
              premiumPlacements: result.gainPositionFive.premiumPlacements,
              positionNumber: 5,
              displayPosition: '5',
              visibilityIncreasePercentage: result.gainPositionOne.visibilityIncreasePercentage
            });
          }
          return _context5.a(2, {
            sovEnabled: result.sovEnabled,
            logoUrl: result.clientLogoUrl,
            displayName: result.clientDisplayName,
            numberOfRegions: result.clientNumberOfRegions,
            currentPosition: result.clientCurrentPosition,
            currentPageNumber: result.clientCurrentPageNumber,
            positionList: positionList,
            visibilityIncreasePercentage: result.gainPositionOne.visibilityIncreasePercentage
          });
      }
    }, _callee5);
  }));
  return _fetchDynamicFaq.apply(this, arguments);
}
export function getLoginDataRequestBody(req) {
  var x = req.cookies ? req.cookies.SSO : undefined;
  var y = req.cookies ? req.cookies['SSO-HMAC'] : undefined;
  return {
    x: x,
    y: y
  };
}